import { z } from "zod";

const coverImageSchema = z.custom<File | null | undefined>(
  (value) => value === undefined || value === null || value instanceof File,
  {
    message: "projects.messages.saveError",
  },
);

export const projectSchema = z.object({
  title: z.string().trim().min(1, "auth.validation.required"),
  genre: z.string().trim().min(1, "auth.validation.required"),
  coverImageFile: coverImageSchema.optional(),
});

export const updateProjectSchema = projectSchema.extend({
  removeCoverImage: z.boolean().optional(),
  artstyleRefPaths: z.array(z.string().trim().min(1)).max(5).optional(),
  styleDescription: z.string().trim().max(2000).optional(),
});

export const projectArtDirectionSchema = z.object({
  styleDescription: z.string().trim().max(2000).default(""),
});

export type ProjectFormValues = z.input<typeof updateProjectSchema>;
export type ProjectFormInput = z.output<typeof updateProjectSchema>;
export type ProjectArtDirectionInput = z.output<typeof projectArtDirectionSchema>;
